import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { insteadOf } from '../../data/content';
export function NotTextbook() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" aria-labelledby="nt-title" data-id="element-245" data-mp="19i9d8vkbfzly">
      <div className="mx-auto max-w-3xl" data-id="element-246" data-mp="15hfoy12yoisj">
        <SectionHeading id="nt-title" lead="You don't need another collection of general explanations about laser technology. You need tools that help organize real professional tasks." data-id="element-247" data-mp="226f0pq2r82ph">
          This is <span className="text-alert" data-id="element-248" data-mp="1t57cy1xv6k9n">not</span> another theoretical laser textbook
        </SectionHeading>

        <p className="mt-10 text-center font-display text-lg font-black uppercase text-accent-600" data-id="element-249" data-mp="1o7fbag7f3js9">
          Built around practical deliverables
        </p>

        <ul className="mt-6 space-y-4" data-id="element-250" data-mp="ho7eeokxb976">
          {insteadOf.map(row => <li key={row.instead} className="overflow-hidden rounded-2xl ring-1 ring-navy-900/10" data-id="element-251" data-mp="cq5uk1fob5un">
              <p className="bg-mist px-4 py-3 text-sm text-ink/60" data-id="element-252" data-mp="iqm5itvv4sgw">
                Instead of <span className="font-semibold text-ink/80 line-through decoration-alert/70" data-id="element-253" data-mp="nnmbl4sppv80">{row.instead.toLowerCase()}</span>
              </p>
              <div className="flex items-start gap-3 bg-white px-4 py-4" data-id="element-254" data-mp="eo7psinhq8tu">
                <ArrowDownIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent-500" aria-hidden="true" data-id="element-255" data-mp="emekb6om5unf" />
                <p className="text-base font-semibold text-navy-900" data-id="element-256" data-mp="3w2mmilztmn8i">{row.get}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-navy-900 p-6 text-center text-white sm:p-8" data-id="element-257" data-mp="3n4kngbzne4nv">
          <p className="text-sm font-bold uppercase tracking-wide text-gold-400" data-id="element-258" data-mp="3r5cwp58is9k5">The goal is simple</p>
          <p className="mt-2 font-display text-xl font-black leading-snug sm:text-2xl" data-id="element-259" data-mp="3d5bnn2i3pvtl">
            Spend less effort organizing your documentation process and more attention applying your clinical expertise.
          </p>
        </div>

        <SectionCTA label="Give me the practical tools" data-id="element-260" data-mp="1nqaosnoprc70" />
      </div>
    </section>;
}